// extracted by mini-css-extract-plugin
module.exports = {"self":"ViewAllFeedbackItemsDialog_self__ByCbK","loading":"ViewAllFeedbackItemsDialog_loading__zfVca"};